var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as ethers from "ethers";
import ERC20Abi from "./ERC20Abi";
import Metamask from "./Metamask";
import Contracts from "./Contracts";
/**
 * High level utility class
 */
var Payment = /** @class */ (function () {
    function Payment() {
    }
    /**
     * build ERC20 transfering ABI
     * @param to receiptor address
     * @param amount wei/min usd unit
     * @returns hex ABI string
     */
    Payment.buildErc20TransferABI = function (to, value) {
        var coder = new ethers.utils.AbiCoder();
        var amount = coder.encode(["uint256"], [value]);
        var erc20 = new ethers.utils.Interface(ERC20Abi);
        var abi = erc20.functions.transfer.encode([to, amount]);
        return abi;
    };
    Payment.parseUnits = function (value, unit) {
        return ethers.utils.parseUnits(value, unit);
    };
    /**
     * Send ETH tx
     * @param param
     * @returns Tx hash, or empty string if failed
     */
    Payment.send = function (_a) {
        var to = _a.to, value = _a.value, currency = _a.currency, data = _a.data;
        return __awaiter(this, void 0, void 0, function () {
            var from, hash, contract;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!Metamask.hasWeb3()) {
                            return [2 /*return*/, ""];
                        }
                        return [4 /*yield*/, Metamask.enable()];
                    case 1:
                        from = (_b.sent())[0];
                        if (!from)
                            return [2 /*return*/, ""];
                        if (!(currency === "eth")) return [3 /*break*/, 3];
                        return [4 /*yield*/, Metamask.sendTransaction({
                                to: to,
                                from: from,
                                value: ethers.utils.parseEther("" + (value || 0)).toHexString(),
                                data: data
                            })];
                    case 2:
                        hash = _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        contract = Contracts[currency];
                        if (!contract) {
                            return [2 /*return*/, ""];
                        }
                        return [4 /*yield*/, Metamask.sendTransaction({
                                to: contract.addr,
                                from: from,
                                value: "0x00",
                                data: Payment.buildErc20TransferABI(to, ethers.utils.parseUnits("" + (value || 0), contract.decimals).toHexString())
                            })];
                    case 4:
                        hash = _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/, hash];
                }
            });
        });
    };
    return Payment;
}());
export default Payment;
//# sourceMappingURL=data:application/json;base64,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